<template>
  <component
    :is="tag"
    class="button"
    :class="[
      {
        'button--loading': loading,
        'button--disabled': disabled,
        'button--block': block
      },
      `button--${type}`
    ]"
    @click="onClick"
  >
    <span
      v-if="loading"
      class="button-loading__spinner"
    />
    <slot v-else />
  </component>
</template>

<script setup>
const props = defineProps({
  tag: {
    type: String,
    default: 'button'
  },
  type: {
    type: String,
    default: 'primary'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['click'])

const onClick = (event) => {
  if (props.loading) {
    event.preventDefault()
  } else if (!props.disabled) {
    emit('click', event)
  }
}
</script>

<style lang="less">
.button {
  position: relative;
  height: 44px;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  font-family: mon-600;
  font-size: 14px;
  transition: all .2s;

  &--primary {
    color: #FFFFFF;
    background: rgba(5, 39, 132, 1);
  }

  &--secondary {
    color: #FFFFFF;
    background: rgba(70, 129, 249, 1);
  }

  &--block {
    display: block;
    width: 100%;
  }

  &--disabled {
    opacity: .6;
    cursor: not-allowed;
  }

  &--loading {
    cursor: not-allowed;
  }

  &-loading {
    &__spinner {
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 2px solid;
      border-top: 2px solid transparent;
      border-radius: 50%;
      animation: spinner 1s linear infinite;
    }
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
